import React, { useEffect } from "react";

import { useAuth0 } from "@auth0/auth0-react";
import { withRouter } from "react-router";

import { providerProps } from "../../utils/auth0";

export default function Logout() {
    const auth0 = useAuth0();

    useEffect(() => {
        let isMounted = true;

        if (auth0.isAuthenticated && isMounted) {
            auth0.logout();
        }

        () => { isMounted = false };
    }, [auth0.isAuthenticated, auth0.logout]);

    if (auth0.isLoading) {
        return <div>Loading...</div>
    } else if (auth0.error) {
        console.warn("Something went wrong with sign out");
        console.error(auth0.error);
        console.dir(auth0);

        return <div>Something went wrong</div>;
    }

    return null;
}



// WEBPACK FOOTER //
// ./app/components/Logout/index.jsx